import { useMutation } from '@tanstack/react-query';
import { api } from '@/shared/api/axios';

export interface ChangePasswordPayload {
  currentPassword: string;
  newPassword: string;
}

export function useChangePassword() {
  return useMutation({
    mutationFn: async (payload: ChangePasswordPayload) => {
      const { data } = await api.post<{ ok: boolean }>('/api/auth/change-password', payload);
      return data;
    },
  });
}
